import React, { Component } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import AuthService from "../../services/auth.service";
import Input from "react-validation/build/input";
import Select from "react-select";
import 'local-date/lib/polyfills/reflect';
import 'local-date/lib/polyfills/array-from';

import {
    Heading,
    FormControl,
    FormLabel,
    Button,
    InputRightElement,
    Text,
    Link,
    Stack,
    Box,
    VStack,
  } from '@chakra-ui/react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { LightBg, ParentCard, Card } from "./style";
import "react-datepicker/dist/react-datepicker.css";

const optionKategori = [
    { value: 0, label: "Startup" },
    { value: 1, label: "Global Company" },
    { value: 2, label: "Multilaterals Organizations" },
    { value: 3, label: "Non-profits Organizations" },
    { value: 4, label: "Hospitals" },
]

const optionSektor = [
    { value: 0, label: "Technology" },
    { value: 1, label: "BUMN" },
    { value: 2, label: "Healthcare and Hospitality" },
    { value: 3, label: "Multilaterals and Non-profits" },
    { value: 4, label: "Professional Services" },
    { value: 5, label: "Others" },
]

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
          Harus diisi!
        </div>
      );
    }
};

const email = value => {
    if (!isEmail(value)) {
        return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
            Email tidak valid!
        </div>
        );
    }
};

const vpassword = value => {
    if (value.length <= 8) {
        return (
        <div className="alert alert-danger" role="alert" style={{height: '30px',paddingTop: '2px'}}>
            Password harus lebih dari 8 karakter!
        </div>
        );
    }
};

export default class RegisterMitra extends Component {
    constructor(props) {
        super(props);
        this.handleRegisterMitra = this.handleRegisterMitra.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
	    this.onChangeNamaResmi = this.onChangeNamaResmi.bind(this);
        this.onChangeNamaBrand = this.onChangeNamaBrand.bind(this);
        this.onChangeWebsite = this.onChangeWebsite.bind(this);
        this.onChangeKategori = this.onChangeKategori.bind(this);
        this.onChangeSektorBisnis = this.onChangeSektorBisnis.bind(this);
        this.onChangeShowPassword = this.onChangeShowPassword.bind(this);
        this.state = {
          emailUser: "",
          password: "",
          namaResmi: "",
          namaBrand: "",
          website: "",
          kategori: "",
          sektorBisnis: "",
          showPassword: false,
          successful: false,
          message: "",
        };
    }

    onChangeNamaResmi(e) {
        this.setState({
          namaResmi: e.target.value
        });
    }

    onChangeEmail(e) {
        this.setState({
            emailUser: e.target.value
        });
    }

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    onChangeNamaBrand(e) {
        this.setState({
            namaBrand: e.target.value
        });
    }

    onChangeWebsite(e) {
        this.setState({
            website: e.target.value
        });
    }

    onChangeKategori(e) {
        this.setState({
            kategori: e.value
        });
    }

    onChangeSektorBisnis(e) {
        this.setState({
            sektorBisnis: e.value
        });
    }

    onChangeShowPassword() {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    handleRegisterMitra(e) {
        e.preventDefault();
        // form.validateAll();
        try {
        if (this.state.emailUser.includes("@gmail.com")) {
             AuthService.registerMitra(
                this.state.emailUser,
                this.state.password,
                this.state.namaResmi,
                this.state.namaBrand,
                this.state.website,
                this.state.kategori,
                this.state.sektorBisnis
                ).then(
                () => {
                    console.log(this.state.emailUser)
                    console.log(this.state.namaResmi)
                    this.setState({
                        message: "Selamat, Anda telah berhasil register!",
                        successful: true,
                    });
                },
                (error) => {
                    console.log(this.state.emailUser)
                    console.log(this.state.namaResmi)
                    console.log(this.state.sektorBisnis)
                    console.log(this.state.kategori)
    
                    let resMessage;
    
                    resMessage = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
    
                        console.log(resMessage);
    
                    if(resMessage.includes("could not execute statement; SQL [n/a]; constraint [UK_5fxlusj9c11kvgahypos561pv]; nested exception is org.hibernate.exception.ConstraintViolationException: could not execute statement")) {
                        this.setState({
                            message: "Email sudah terdaftar",
                            successful: false,
                        });
                    }
                    else if(resMessage.includes("ConstraintViolationImpl{interpolatedMessage='must not be null', propertyPath=kategori, rootBeanClass=class pabrykuniversity.magangprodb.be.model.MitraModel, messageTemplate='{javax.validation.constraints.NotNull.message}'}")) {
                        this.setState({
                            message: "Kategori belum anda pilih",
                            successful: false,
                        });
                    }
                    else if(resMessage.includes("ConstraintViolationImpl{interpolatedMessage='must not be null', propertyPath=sektorBisnis, rootBeanClass=class pabrykuniversity.magangprodb.be.model.MitraModel, messageTemplate='{javax.validation.constraints.NotNull.message}'}")) {
                        this.setState({
                            message: "Sektor bisnis belum anda pilih",
                            successful: false,
                        });
                    }
                    
                    else if(this.state.sektorBisnis.includes("--Pilih kategori mitra--")){
                        this.setState({
                            message: "Sektor bisnis belum anda pilih",
                            successful: false,
                        });
                    }
                    else if(this.state.sektorBisnis.includes("--Pilih sektor bisnis--")){
                        this.setState({
                            message: "Kategori belum anda pilih",
                            successful: false,
                        });
                    }
                    else if(!(this.state.emailUser.includes("@gmail.com"))){
                        this.setState({
                            message: "Masukkan email yang valid",
                            successful: false,
                        });
                    }
                     else {
                        this.setState({
                            message: "Terjadi kesalahan, coba lagi",
                            successful: false,
                        });
                    }
                }            
              );
        }
        else{
            AuthService.registerMitra(
                this.state.emailUser,
                this.state.password,
                this.state.namaResmi,
                this.state.namaBrand,
                this.state.website,
                this.state.kategori,
                this.state.sektorBisnis
                ).then(
                    (error) => {
                        console.log(this.state.emailUser)
                        console.log(this.state.namaResmi)
                        console.log(this.state.sektorBisnis)
                        console.log(this.state.kategori)
                        
                        this.setState({
                            message: "Email yang anda masukkan tidak valid",
                            successful: false,
                        });
                    }     
                )
        }
        } catch (err) {
          console.log(err);
        }
    };

    render() {
        return (
            <>
            <LightBg>
                <ParentCard>
                    <Card>
                        <Stack>
                            <Box>
                                <Heading paddingBottom={10} textAlign={'center'} fontFamily={'Inter'}>Daftar</Heading>
                            </Box>
                            <Box>
                                <VStack spacing={4} align='stretch'>
                                    <Form
                                    onSubmit={this.handleRegisterMitra}
                                    ref={c => {
                                      this.form = c;
                                    }}
                                    >
                                    {!this.state.successful && (
                                    <div>
                                        <Box pt={4}>
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='namaResmi'>Nama Resmi</FormLabel>
                                                <Input 
                                                style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                id='namaResmi' 
                                                placeholder='Masukkan nama resmi'
                                                value={this.state.namaResmi}
                                                validations={[required]}
                                                onChange={this.onChangeNamaResmi} />
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}>
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='namaBrand'>Nama Brand</FormLabel>
                                                <Input 
                                                style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                id='namaBrand' 
                                                placeholder='Masukkan nama brand'
                                                value={this.state.namaBrand}
                                                validations={[required]}
                                                onChange={this.onChangeNamaBrand} />
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}>
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='website'>Website</FormLabel>
                                                <Input 
                                                style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                id='website' 
                                                placeholder='Masukkan nama website'
                                                value={this.state.website}
                                                validations={[required]}
                                                onChange={this.onChangeWebsite} />
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='kategori'>Kategori</FormLabel>
                                                <Select
                                                style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                id='kategori' 
                                                options={optionKategori}
                                                onChange={this.onChangeKategori.bind(this)}
                                                value={optionKategori.find((obj) => obj.value === this.state.kategori)}
                                                placeholder="--Pilih kategori mitra--" />
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='sektorBisnis'>Sektor Bisnis</FormLabel>
                                                <Select
                                                style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                id='sektorBisnis' 
                                                options={optionSektor}
                                                onChange={this.onChangeSektorBisnis.bind(this)}
                                                value={optionSektor.find((obj) => obj.value === this.state.sektorBisnis)}
                                                placeholder="--Pilih sektor bisnis--" />
                                            </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                        <FormControl isRequired fontFamily={'Inter'}>
                                            <FormLabel htmlFor='email'>Email</FormLabel>
                                            <Input style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}}  
                                            id='emailUser' 
                                            placeholder='Masukkan alamat email' 
                                            value={this.state.emailUser}
                                            validations={[required,email]}
                                            onChange={this.onChangeEmail}/>
                                        </FormControl>
                                        </Box>
                                        <Box pt={4}> 
                                            <FormControl id='password' isRequired fontFamily={'Inter'}>
                                                <FormLabel htmlFor='katasandi'>Kata sandi</FormLabel>
                                                <div>
                                                    <Input style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                                    placeholder='Masukkan kata sandi' 
                                                    value={this.state.password}
                                                    type={this.state.showPassword ? 'text' : 'password'}
                                                    validations={[required,vpassword]}
                                                    onChange={this.onChangePassword}/>
                                                    <InputRightElement h={'full'}>
                                                        <Button
                                                            variant={'ghost'}
                                                            onClick={this.onChangeShowPassword}
                                                        >
                                                            {this.state.showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                                        </Button>
                                                    </InputRightElement>
                                                </div>
                                            </FormControl>
                                        </Box>
                
                                        <Box fontFamily={'Inter'} align={'center'}>
                                            <Button style={{paddingTop: "6px", paddingBottom: "6px", background:'#6554C0', color:'#FFFFFF', justifyContent:'center'}} 
                                                mt={4} type='submit'>Daftar</Button>
                                        </Box>
                                    </div>
                                    )}
                                        {this.state.message && (
                                        <div className="form-group">
                                            <div
                                            className={
                                                this.state.successful
                                                ? "alert alert-success"
                                                : "alert alert-danger"
                                            }
                                            role="alert"
                                            >
                                            {this.state.message}
                                            </div>
                                        </div>
                                        )}
                                        <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                            this.checkBtn = c;
                                        }}
                                        />
                                    </Form>
                                </VStack>
                            </Box>
                            <Box fontFamily={'Inter'} >
                                <Text align={'center'}>Sudah punya akun? <Link href="/login" color={'blue.400'}>Masuk</Link></Text>
                            </Box>
                        </Stack>
                    </Card>
                </ParentCard>
            </LightBg>
            </>
        );
    }
}